import axios from "axios";
import { DEPLOYED_BASE_URL, BASE_URL } from "./congif";


const axiosnew = axios.create({
  baseURL: DEPLOYED_BASE_URL,
  // baseURL: BASE_URL,
  withCredentials: true,
});

axiosnew.interceptors.request.use(
  (config) => {
    const currentUser = JSON.parse(localStorage.getItem('user'));

    if (currentUser && currentUser.token) {
      config.headers['Authorization'] = `Bearer ${currentUser.token}`;
    }


    return config;
  },
  (error) => {
    return Promise.reject(error);
  }

);

axiosnew.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    console.log(originalRequest)
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {

        const res = await axiosnew.post('/user/refresh-token');

        if (res.status === 200) {

          const newAccessToken = res.data.accessToken;

          axios.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
          originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;

          const currentUser = JSON.parse(localStorage.getItem('user'));

          if (currentUser) {
            currentUser.token = newAccessToken;
            localStorage.setItem('user', JSON.stringify(currentUser));
          }

          return axiosnew(originalRequest);

        }
      } catch (refreshError) {

        console.error("Refresh token failed:", refreshError);
        return Promise.reject(refreshError);
      }
    }


    return Promise.reject(error);
  }
);

export default axiosnew;
